if (!customElements.get('pdp-reviews')) {
  customElements.define(
    'pdp-reviews',
    class PdpReviews extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-pdp-reviews-scroller]');
        this.track = this.querySelector('[data-pdp-reviews-track]');
        this.cards = Array.from(this.querySelectorAll('[data-pdp-reviews-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-pdp-reviews-dot]'));
        this.prevButtons = Array.from(this.querySelectorAll('[data-pdp-reviews-prev]'));
        this.nextButtons = Array.from(this.querySelectorAll('[data-pdp-reviews-next]'));
        this.index = 0;
        this.desktopQuery = window.matchMedia('(min-width: 1024px)');

        this.prevButtons.forEach((button) => {
          button.addEventListener('click', () => this.go(-1));
        });
        this.nextButtons.forEach((button) => {
          button.addEventListener('click', () => this.go(1));
        });
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index));
        });

        this.onScroll = () => {
          if (this.desktopQuery.matches) return;
          this.syncFromScroll();
        };
        this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });

        this.onResize = () => this.render(false);
        this.desktopQuery.addEventListener('change', this.onResize);
        window.addEventListener('resize', this.onResize);

        this.render(false);
      }

      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.onScroll);
        this.desktopQuery.removeEventListener('change', this.onResize);
        window.removeEventListener('resize', this.onResize);
      }

      perView() {
        return this.desktopQuery.matches ? Math.min(3, this.cards.length) : 1;
      }

      maxIndex() {
        return Math.max(0, this.cards.length - this.perView());
      }

      go(delta) {
        this.goTo(this.index + delta);
      }

      goTo(index) {
        const max = this.maxIndex();
        const total = max + 1;
        this.index = ((index % total) + total) % total;
        this.render(true);
      }

      syncFromScroll() {
        if (!this.scroller || !this.cards[0]) return;
        const left = this.scroller.scrollLeft;
        let nearest = 0;
        let nearestDist = Infinity;
        this.cards.forEach((card, index) => {
          const dist = Math.abs(card.offsetLeft - left);
          if (dist < nearestDist) {
            nearest = index;
            nearestDist = dist;
          }
        });
        if (nearest !== this.index) {
          this.index = nearest;
          this.updateDots();
        }
      }

      render(animate) {
        this.index = Math.min(this.index, this.maxIndex());

        if (this.desktopQuery.matches) {
          const card = this.cards[0];
          const styles = this.track ? window.getComputedStyle(this.track) : null;
          const gap = styles ? parseFloat(styles.columnGap || styles.gap) || 20 : 20;
          const step = card ? card.getBoundingClientRect().width + gap : 0;
          if (this.track) {
            this.track.style.transition = animate ? '' : 'none';
            this.track.style.transform = `translateX(${-this.index * step}px)`;
          }
          if (this.scroller) this.scroller.scrollLeft = 0;
        } else if (this.scroller && this.cards[this.index]) {
          if (this.track) this.track.style.transform = '';
          const card = this.cards[this.index];
          this.scroller.scrollTo({
            left: card.offsetLeft - (this.track ? this.track.offsetLeft : 0),
            behavior: animate ? 'smooth' : 'auto',
          });
        }

        this.updateDots();
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    }
  );
}
